import { useEffect, type FC } from 'react';

import { Button, Typography } from 'pixel-react';

import WEBSITE_ENVIRONMENT_URL_CONFIG from '@/config/website-env-url-config';

import { SignUpWrapper } from '../SignUpWrapper';
import styles from './AccountLocked.module.scss';

export const AccountLocked: FC = () => {
  const clientName = import.meta.env.VITE_CLIENT_DETAIL?.name;

  const handleContactUs = () => {
    window.location.href =
      WEBSITE_ENVIRONMENT_URL_CONFIG?.PRODUCTION_CONTACTUS_URL;
  };

  useEffect(() => {
    const handleKeyPress = (event: KeyboardEvent) => {
      if (event.key === 'Enter') {
        handleContactUs();
      }
    };

    window.addEventListener('keydown', handleKeyPress);

    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, []);

  return (
    <SignUpWrapper
      content_header={
        <>
          {' '}
          <Typography fontSize="24px" fontWeight="bold">
            Test Automation at lightning speed- {clientName} AI
          </Typography>{' '}
        </>
      }
      sub_content={`Experience automatic development of test cases and automation scripts enabled using our ${clientName} AI.`}
      footer_content={`${clientName}: High Speed Testing, Simplified!`}
      copyright_content={`Copyright © ${clientName} Pvt Ltd. All Rights Reserved`}
      className={styles.account_locked_container}
    >
      <section className={styles.form_container}>
        <aside className={styles.account_locked_form}>
          <section className={styles.acc_locked_form_header}>
            <Typography fontSize="32px" className={styles['header_text']}>
              Account Temporarily Locked
            </Typography>
            <Typography
              fontSize="16px"
              textAlign="center"
              lineHeight="22px"
              className={styles['sub_header_text']}
            >
              Your account has been temporarily locked due to multiple failed
              login attempts. Please try again after{' '}
              <Typography
                fontSize="16px"
                className={styles['highlighted_text']}
              >
                5 Minutes
              </Typography>
              . For immediate assistance, use the{' '}
              <Typography
                fontSize="16px"
                className={styles['highlighted_text']}
              >
                “Contact Us”
              </Typography>{' '}
              button.
            </Typography>

            <Typography
              fontSize="16px"
              textAlign="center"
              className={styles['sub_count_header_text']}
            >
              Thank you for your understanding and cooperation.
            </Typography>
          </section>

          <div className={styles.forgotPassword_footerBtn}>
            <Button
              type="submit"
              variant="primary"
              buttonWidth="155.03px"
              onClick={handleContactUs}
            >
              <Typography fontSize="16px" fontWeight="bold">
                Contact Us
              </Typography>
            </Button>
          </div>
        </aside>
      </section>
    </SignUpWrapper>
  );
};
